import fetchJSON from '@gaia/utils/fetchJSON';

interface CustomMapSourceRequest {
    notes: string;
    title: string;
    tile_url: string;
    min_zoom: number;
    max_zoom: number;
    reversed_y_axis: boolean;
}

interface CustomMapSourceResponse {
    sw_lon: number;
    sw_lat: number;
    ne_lon: number;
    ne_lat: number;
    name: string;
    notes: string;
    unique_cache_key: string;
    min_zoom: number;
    max_zoom: number;
    title: string;
    tile_url: string;
    reversed_y_axis: boolean;
}

export default async function saveCustomMapSource({
    title,
    tile_url,
    min_zoom,
    max_zoom,
    notes,
    reversed_y_axis,
}: CustomMapSourceRequest): Promise<CustomMapSourceResponse> {
    return await fetchJSON('/api/objects/mapsource/', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            notes,
            title,
            tile_url,
            min_zoom,
            max_zoom,
            reversed_y_axis,
        }),
    });
}
